import React from 'react';
import PropTypes from 'prop-types';
import IconButton from "@mui/material/IconButton";
import CloseIcon from '@mui/icons-material/Close';
import { Box, Chip } from "@mui/material";
import Card from "@mui/material/Card";
import TermsFilter from "./components/TermsFilter";
import Tooltip from "@mui/material/Tooltip";
import EmailFilter from "./components/EmailFilter";
import {useSoftUIController} from "../../context";
import {SUPER_ADMIN_ROLE, LIBRARY_ADMIN_ROLE} from "../../utlis/constant";
import {useTranslation} from "react-i18next";

function FilterList({
                        filterCollapsed,
                        handleFilterCollapseToggle,
                        selectedSubjects,
                        selectedLanguages,
                        handleCheckboxSubjectChange,
                        handleCheckboxLanguageChange,
                        handleClearAll,
                        clearEmail,
                        searchSubjectTerm,
                        setSearchSubjectTerm,
                        searchLanguageTerm,
                        setSearchLanguageTerm,
                        subjects,
                        languages,
                        emailValue,
                        email,
                        setEmail,
                        subjectCollapsed,
                        handleSubjectCollapseToggle,
                        languageCollapsed,
                        handleLanguageCollapseToggle,
                        handleEmailChange,
                        isDrawerMode = false,
                    }) {

    const [controller] = useSoftUIController();
    const {role, direction} = controller;
    const rolesAllowed = [SUPER_ADMIN_ROLE, LIBRARY_ADMIN_ROLE]
    const shouldRender = isDrawerMode || !filterCollapsed;

    if (!shouldRender) return null;
    const { t } = useTranslation("publicationsTranslation");

    return (
        <Box
            sx={{
                width: isDrawerMode ? '100%' : '20%',
                marginRight: isDrawerMode ? 0 : '10px',
                height: '100%',
            }}
        >
            <Card sx={{
                padding: '20px',
                height: '100%',
                color: '#344767',
                backgroundColor: '#f8f9fa',
                boxShadow: 'none !important',
                border: isDrawerMode ? 'none' : '1px solid rgba(0,0,0,0.12)',
                overflow: 'hidden'
            }}>
                <Box sx={{
                    flexShrink: 0, // Prevents this from shrinking
                    mb: 1
                }}>
                <div style={{
                    position: 'relative',
                    height: '30px',
                    display: 'flex',
                    justifyContent: 'space-between',
                }}>
                    <IconButton
                        onClick={handleClearAll}
                        style={{
                            borderRadius: '10%',
                            backgroundColor: '#f0f0f0',
                            fontSize: '0.7rem',
                        }}
                    >
                        {t("clearAll")}
                    </IconButton>

                    {!isDrawerMode && (
                        <Tooltip title="Close">
                            <IconButton
                                onClick={handleFilterCollapseToggle}
                                style={{
                                    backgroundColor: '#f0f0f0',
                                    fontSize: '0.7rem',
                                }}
                            >
                                <CloseIcon />
                            </IconButton>
                        </Tooltip>
                    )}
                </div>


                <Box sx={{ marginTop: '10px', display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
                    {rolesAllowed.includes(role) && emailValue &&  <Chip
                        key={"email-index"}
                        label={emailValue}
                        onDelete={() => handleEmailChange("")}
                        sx={{
                            margin: '5px 0',
                            '& .MuiChip-deleteIcon': {
                                margin: direction === 'rtl' ? '0px -6px 0px 5px' : '0px 5px 0px -6px'
                            }
                        }}
                    />}

                    {selectedSubjects.map((subject, index) => (
                        <Chip
                            key={index}
                            label={subject.name}
                            onDelete={() => handleCheckboxSubjectChange(subject)}
                            sx={{
                                margin: '5px 0',
                                '& .MuiChip-deleteIcon': {
                                    margin: direction === 'rtl' ? '0px -6px 0px 5px' : '0px 5px 0px -6px'
                                }
                            }}
                        />
                    ))}

                    {selectedLanguages.map((language, index) => (
                        <Chip
                            key={index}
                            label={language.language}
                            onDelete={() => handleCheckboxLanguageChange(language)}
                            sx={{
                                margin: '5px 0',
                                '& .MuiChip-deleteIcon': {
                                    margin: direction === 'rtl' ? '0px -6px 0px 5px' : '0px 5px 0px -6px'
                                }
                            }}
                        />
                    ))}
                </Box>
                </Box>

                <Box sx={{
                    flexGrow: 1,
                    overflowY: 'auto',
                    // Add styling for the scrollbar
                    '&::-webkit-scrollbar': {
                        width: '8px',
                    },
                    '&::-webkit-scrollbar-track': {
                        backgroundColor: '#f1f1f1',
                        borderRadius: '4px',
                    },
                    '&::-webkit-scrollbar-thumb': {
                        backgroundColor: '#c1c1c1',
                        borderRadius: '4px',
                        '&:hover': {
                            backgroundColor: '#a8a8a8',
                        },
                    },
                    scrollbarWidth: 'thin',
                    scrollbarColor: '#c1c1c1 #f1f1f1',
                }}>
                    {rolesAllowed.includes(role) && <EmailFilter
                        title={t("emailAddress")}
                        handleEmailChange={handleEmailChange}
                        placeholder={t("searchByEmail")}
                        emailValue={emailValue}
                        email={email}
                        setEmail={setEmail}
                        clearEmail={clearEmail}
                    />}
                    <TermsFilter
                    title={t("subjectTerms")}
                    searchTerm={searchSubjectTerm}
                    setSearchTerm={setSearchSubjectTerm}
                    terms={subjects}
                    selectedTerms={selectedSubjects}
                    handleCheckboxChange={handleCheckboxSubjectChange}
                    termCollapsed={subjectCollapsed}
                    handleTermCollapseToggle={handleSubjectCollapseToggle}
                    itemKey="name"
                    placeholder={t("searchSubjects")}

                />

                <TermsFilter
                    title={t("languages")}
                    searchTerm={searchLanguageTerm}
                    setSearchTerm={setSearchLanguageTerm}
                    terms={languages}
                    selectedTerms={selectedLanguages}
                    handleCheckboxChange={handleCheckboxLanguageChange}
                    termCollapsed={languageCollapsed}
                    handleTermCollapseToggle={handleLanguageCollapseToggle}
                    itemKey="language"
                    placeholder={t("searchLanguages")}

                />

                </Box>
            </Card>
        </Box>
    );
};

FilterList.propTypes = {
    filterCollapsed: PropTypes.bool.isRequired,
    handleFilterCollapseToggle: PropTypes.func.isRequired,
    selectedSubjects: PropTypes.arrayOf(PropTypes.string).isRequired,
    selectedLanguages: PropTypes.arrayOf(PropTypes.string).isRequired,
    emailValue: PropTypes.string,
    email: PropTypes.string,
    setEmail: PropTypes.func,
    clearEmail: PropTypes.func,
    handleEmailChange: PropTypes.func,
    handleCheckboxSubjectChange: PropTypes.func.isRequired,
    handleCheckboxLanguageChange: PropTypes.func.isRequired,
    handleClearAll: PropTypes.func.isRequired,
    searchSubjectTerm: PropTypes.string.isRequired,
    setSearchSubjectTerm: PropTypes.func.isRequired,
    searchLanguageTerm: PropTypes.string.isRequired,
    setSearchLanguageTerm: PropTypes.func.isRequired,
    subjects: PropTypes.arrayOf(PropTypes.object).isRequired,
    languages: PropTypes.arrayOf(PropTypes.object).isRequired,
    subjectCollapsed: PropTypes.bool.isRequired,
    handleSubjectCollapseToggle: PropTypes.func.isRequired,
    languageCollapsed: PropTypes.bool.isRequired,
    handleLanguageCollapseToggle: PropTypes.func.isRequired,
    isDrawerMode: PropTypes.bool,
};

export default FilterList;
